<script>
export default {
    props: {
        query: {
            type: String,
            default: '',
        },
    },
    emits: ['update:query'],
    methods: {
        onInput(event) {
            this.$emit('update:query', event.target.value);
        },
        clear() {
            this.$emit('update:query', '');
        },
    },
};
</script>

<template>
    <div class="sidebar-search__wrapper">
        <svg class="sidebar-search__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
            <circle cx="6.5" cy="6.5" r="4" stroke="currentColor" stroke-width="1.4"/>
            <line x1="9.6" y1="9.6" x2="13" y2="13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
        </svg>
        <input
            class="sidebar-search__input"
            type="text"
            placeholder="Find section..."
            :value="query"
            @input="onInput"
        />
        <span
            v-if="query"
            class="sidebar-search__clear"
            @click="clear"
        >×</span>
    </div>
</template>
